import React, { Component } from 'react';
import { string, object } from 'yup';
import { Formik } from 'formik';
import BriefTemplateForm from './brief_template_form';
import BriefTemplateWrapper from './brief_template_wrapper';
import { get, patch } from '../../utils/api';
import { handleError, handleSubmitError } from '../../utils/errors';
import GrapeFormat, {
  formatOptions,
  formatOption,
  formatRawAsOptions
} from '../../utils/formatters/formik-grape-formatter';

export default class EditBriefTemplate extends Component {
  constructor(props) {
    super(props);
    const { brandProfileId, briefTemplateId, accountId } = JSON.parse(props.appData);

    this.state = {
      brandProfileId,
      briefTemplateId,
      accountId,
      name: '',
      description: '',
      campaigns: [],
      pillar: '',
      audience: '',
      storyFormat: '',
      tags: [],
      fieldTemplates: [],
      mountError: false
    };
  }

  componentDidMount() {
    const { briefTemplateId } = this.state;

    return get(`/api/v1/brief_templates/${briefTemplateId}`)
      .then(data => {
        this.setState({
          name: data.name,
          campaigns: formatOptions(data.campaigns),
          audience: formatOption(data.audience),
          pillar: formatOption(data.pillar),
          storyFormat: data.storyFormat,
          description: data.description,
          tags: formatOptions(data.tags),
          fieldTemplates: data.fieldTemplates.map(fieldTemplate => fieldTemplate.id),
          parentFetching: false
        });
      })
      .catch(errorResponse => {
        handleError(errorResponse, () => {
          this.setState({ mountError: true });
        });
      });
  }

  render() {
    return (
      <BriefTemplateWrapper>
        <Formik
          initialValues={{ ...this.state }}
          validationSchema={object().shape({
            name: string().required('Name is required'),
            storyFormat: string().required('Story format is required')
          })}
          onSubmit={(values, actions) => {
            const { briefTemplateId } = this.state;
            patch(
              `/api/v1/brief_templates/${briefTemplateId}`,
              JSON.stringify(
                GrapeFormat({
                  ...values,
                  fieldTemplates: formatRawAsOptions(values.fieldTemplates)
                })
              )
            )
              .then(() => window.location.replace('../'))
              .catch(errorResponse => {
                handleSubmitError(
                  errorResponse,
                  actions,
                  'There was an error saving your brief template.'
                );
              });
          }}
          render={props => <BriefTemplateForm {...props} streamingData={this.state} />}
        />
      </BriefTemplateWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/brief_templates/edit_brief_template.jsx